import { render } from "./DsLink.vue?vue&type=template&id=fe5ef29a&scoped=true"
import script from "./DsLink.vue?vue&type=script&lang=js"
export * from "./DsLink.vue?vue&type=script&lang=js"

import "./DsLink.vue?vue&type=style&index=0&id=fe5ef29a&scoped=true&lang=scss"
import "./DsLink.vue?vue&type=style&index=1&id=fe5ef29a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5ef29a"]])

export default __exports__